import {
  Box,
  Flex,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  SystemStyleObject,
  Text,
  useBreakpointValue,
  useColorModeValue,
  useConst,
  VStack,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import React from 'react';
import { FiChevronDown, FiUser } from 'react-icons/fi';

import { AppError } from '../../../framework/models/errors';
import { pageKeywords, pagePaths } from '../../constants/Page';
import { useGlobalStateMachine } from '../../GlobalStore';
import { useEngeneNavigate } from '../../hooks/navigate';
import {
  usePostAssignWorkInfo,
  usePostAssignWorkInfoSearch,
} from '../../hooks/queries/assignWorkInfo';
import { useGetAttachedFileDownload } from '../../hooks/queries/attachedFile';
import { Display, OnClickButton, Spacing } from '../../models/properties';

/**
 * 個人メニュー
 *
 * @returns
 */
const PersonalMenu: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();

  const spacing = useBreakpointValue<Spacing>({ base: '0', md: '6' });

  const menuButtonFocus = useConst<SystemStyleObject>({ boxShadow: 'none' });
  const userNameDisplay = useBreakpointValue<Display>({
    base: 'none',
    md: 'flex',
  });

  return (
    <HStack spacing={spacing}>
      <Flex alignItems="center">
        <Menu>
          <MenuButton
            paddingY={2}
            transition="all 0.3s"
            _focus={menuButtonFocus}
          >
            <HStack>
              <Icon as={FiUser} size="sm" />
              <VStack
                alignItems="flex-start"
                display={userNameDisplay}
                marginLeft="2"
                spacing="1px"
              >
                <Text fontSize="sm">{state.userInfo?.name}</Text>
              </VStack>
              <Box display={userNameDisplay}>
                <FiChevronDown />
              </Box>
            </HStack>
          </MenuButton>
          <PersonalMenuBody />
        </Menu>
      </Flex>
    </HStack>
  );
};

/**
 * 個人メニュー本体
 *
 * @returns
 */
const PersonalMenuBody: React.FunctionComponent = () => {
  const { actions } = useGlobalStateMachine();
  const navigate = useEngeneNavigate();
  const onClickUserInfo = React.useCallback<OnClickButton>(
    () => navigate(`${pagePaths.USER_INFO}/${pageKeywords.mode.VIEW}`),
    []
  );
  const onClickPassword = React.useCallback<OnClickButton>(
    () => navigate(pagePaths.PASSWORD),
    []
  );
  const onClickLogout = React.useCallback<OnClickButton>(() => {
    actions.logout();
    // keycloak.logout().then(() => navigate(pagePaths.ROOT));
  }, []);

  const api = usePostAssignWorkInfo();

  return (
    <MenuList
      bg={useColorModeValue('white', 'gray.900')}
      borderColor={useColorModeValue('gray.200', 'gray.700')}
    >
      <MenuItem onClick={onClickUserInfo}>個人情報設定</MenuItem>
      <MenuItem onClick={onClickPassword}>パスワード変更</MenuItem>
      <MenuDivider />
      <MenuItem onClick={onClickLogout}>ログアウト</MenuItem>
      <MenuItem hidden onClick={() => api.mutate({})}>
        エラー
      </MenuItem>
    </MenuList>
  );
};

export default PersonalMenu;
